// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"facbecb4","667":"ad34b8be","977":"d42c2909"}[chunkId] + ".chunk.js";
};